import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Order } from '@app/feature/end-user/models/order';
import { environment } from '@env/environment';
import { AppConstant } from '@app/shared/constants';
import { ApiResponse, APIResponse } from '@app/shared/services/core/ICore.interface';
import { IlistOrder } from '@app/feature/store-admin/components/reports/order-shopify/IlistOrder';
import { GetOrdersInterface } from '@app/shared/services/order/GetOrders.interface';
import { CancelOrderRequestModel } from '@app/shared/models/cancel-order-request.interface';
import { ReportOrderRequestModel } from '@app/shared/models/report-order';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private http: HttpClient) { }

  /**Function to make api call for creating a order */
  CreateOrder(order: Order) {
    return this.http.post(environment.baseUrl + AppConstant.CreateOrder, order);
  }

  /**Gets order listing with params: filterid, skipNoOfRecord, takeNoRecord, IsPaginationFilteringRequired.
     * IsPaginationFilteringRequired = false, means pagination, searching, filterinig is not required */
  GetOrdersShopify(userid: number, skipNoOfRecord: number, takeNoRecord: number,
    orderStatusFilterId: number, StoreId: number, storesID: number[],
    orderedUserName: string,
    orderUserEmail: string,
    orderNumber: string,
    isOrderDesk: boolean,
    style: string,
    startDate: string,
    endDate: string) {
    return this.http.post<APIResponse<IlistOrder[]>>(environment.baseUrl + AppConstant.GetOrderListShopify, {
      UserId: userid,
      skipRecords: skipNoOfRecord,
      takeRecords: takeNoRecord,
      orderStatusFilterId: orderStatusFilterId,
      StoreId: StoreId,
      StoresId: storesID,
      OrderedUserName: orderedUserName,
      OrderUserEmail: orderUserEmail,
      OrderNumber: orderNumber,
      IsOrderDesk: isOrderDesk,
      StyleType: style,
      StartDate: startDate,
      EndDate: endDate
    });
  }


  GetTranscations(customerId: string) {
    return this.http.post<any>(environment.baseUrl + AppConstant.GetTranscations, {
      customerID: customerId
    });
  }

  CancelTranscation(idTranscation: string) {
    return this.http.post<any>(environment.baseUrl + AppConstant.CancelTranscation, {
      'orderId': idTranscation
    });
  }

  /**Gets order listing with params: filterid, skipNoOfRecord, takeNoRecord, IsPaginationFilteringRequired.
   * IsPaginationFilteringRequired = false, means pagination, searching, filterinig is not required */
  GetOrders(userid: number, skipNoOfRecord: number, takeNoRecord: number,
    orderStatusFilterId: number, orderNumber: string, orderedUserName: string, orderUserEmail: string, isOrderDesk: boolean) {
    return this.http.get<APIResponse<GetOrdersInterface[]>>(environment.baseUrl + AppConstant.GetOrderList + '?UserId=' + userid +
      '&skipRecords=' + skipNoOfRecord + '&takeRecords=' + takeNoRecord +
      '&orderStatusFilterId=' + orderStatusFilterId +
      '&OrderNumber=' + orderNumber +
      '&OrderedUserName=' + orderedUserName +
      '&OrderUserEmail=' + orderUserEmail + 
      '&IsOrderDesk=' + isOrderDesk);
  }


  /**Function to make api call for order detail */
  GetOrderDetail(orderNo: string) {
    return this.http.get<any>(environment.baseUrl + AppConstant.GetOrderDetail + '?OrderNo=' + orderNo);
  }

  UpdateOrder(userId: number, orderId: number, orderStatus: number, impressOrder: string) {
    return this.http.get<any>(environment.baseUrl + AppConstant.UpdateOrder + '?UserId=' + userId +
      '&OrderId=' + orderId + '&OrderStatus=' + orderStatus + '&ImpressOrder=' + impressOrder);
  }

  AddOrderRatingReview(RatingModel: any) {
    return this.http.post<any>(environment.baseUrl + AppConstant.AddOrderRatingReview, RatingModel);
  }

  getorderRatingReview(userId: any, orderNumber: any, productId: any) {
    return this.http.get<any>(environment.baseUrl + AppConstant.GetUserReviewList + '?UserId=' + userId + '&OrderNumber=' + orderNumber + '&ProductId=' + productId);
  }


  requestSubmitOrderToOrderDesk(orderId: any) {
    return this.http.get<any>(environment.baseUrl + AppConstant.UpdateSingleOrderToOrderDesk + '?orderId=' + orderId);
  }

  requestRegenerateArtworkNo(customizedProductid: any, orderNo:any) {
    return this.http.get<any>(environment.baseUrl + AppConstant.RequestRegenerateArtworkNo + '?customizedProductid=' + customizedProductid + '&orderNo=' + orderNo);
  }

  GetCancelOrderRequest(filterModel: any) {
    return this.http.get<APIResponse<CancelOrderRequestModel[]>>(environment.baseUrl + AppConstant.GET_CANCEL_ORDER_REQUEST_LIST, { params: filterModel });
  }

  UpdateCancelOrderRequestStatus(status: number, refundAmount: number, cancelRequestId: number){
    return this.http.post<ApiResponse>(environment.baseUrl + AppConstant.UPDATE_CANCEL_ORDER_REQUEST_STATUS, {
      cancelRequestId: cancelRequestId,
      status: status,
      refundAmount: refundAmount
    });
  }

  ReportOrderReplacement(data : any){
    return this.http.post<ApiResponse>(environment.baseUrl + AppConstant.REPORT_ORDER_REPLACEMENT, data);
  }

  ReportOrder(data : any){
    return this.http.post<ApiResponse>(environment.baseUrl + AppConstant.REPORT_ORDER, data);
  }
  GetReportOrderRequests(filterModel: any) {
    return this.http.get<APIResponse<ReportOrderRequestModel[]>>(environment.baseUrl + AppConstant.GET_REPORT_ORDER_REQUEST_LIST, { params: filterModel });
  }
  UpdateReportOrderRequestStatus(status: number, reportRequestId: number){
    return this.http.post<ApiResponse>(environment.baseUrl + AppConstant.UPDATE_REPORT_ORDER_REQUEST_STATUS, { reportRequestId: reportRequestId, status : status });
  }
  DownloadOpenAPIInvoice(fromDate: string, toDate: string, userId: number){
    return this.http.get(environment.baseUrl + AppConstant.DOWNLOAD_OPENAPI_INVOICE + '?fromDate=' + fromDate + '&toDate=' + toDate + '&userId=' + userId, {
      responseType: 'blob',
       observe: 'response'
    });
  }
  UploadOpenAPIInvoice(formdata: FormData) {
    return this.http.post<any>(environment.baseUrl + AppConstant.UPLOAD_OPENAPI_INVOICE, formdata);
  }
  RequestCancelOrder(data: any) {
    return this.http.post<ApiResponse>(environment.baseUrl + AppConstant.REQUEST_ORDER_CANCEL, data);
  }
  UploadImpressInvoice(formdata: FormData) {
    return this.http.post<any>(environment.baseUrl + AppConstant.UPLOAD_IMPRESS_INVOICE, formdata);
  }
  UploadMarkShippedImpress(formdata: FormData) {
    return this.http.post<any>(environment.baseUrl + AppConstant.UPLOAD_MARK_ORDER_SHIPPED_IMPRESS, formdata);
  }
  // WI 1711: async Mark-Shipped bulk-job reads
  getBulkJobs(type: string, take: number = 10) {
    return this.http.get<ApiResponse>(
      `${environment.baseUrl}${AppConstant.BULK_JOBS}?type=${encodeURIComponent(type)}&take=${take}`
    );
  }
  getBulkJob(id: number) {
    return this.http.get<ApiResponse>(`${environment.baseUrl}${AppConstant.BULK_JOBS}/${id}`);
  }
  exportBulkJob(id: number) {
    return this.http.get(`${environment.baseUrl}${AppConstant.BULK_JOBS}/${id}/export`, {
      responseType: "blob",
    });
  }
  ExportExcel(userid: number, skipNoOfRecord: number, takeNoRecord: number,
    orderStatusFilterId: number, StoreId: number, storesID: number[],
    orderedUserName: string,
    orderUserEmail: string,
    orderNumber: string,
    isOrderDesk: boolean,
    style: string,
    startDate: string,
    endDate: string) {
    return this.http.post<any>(environment.baseUrl + AppConstant.ExportOrder, {
      UserId: userid,
      skipRecords: skipNoOfRecord,
      takeRecords: takeNoRecord,
      orderStatusFilterId: orderStatusFilterId,
      StoreId: StoreId,
      StoresId: storesID,
      OrderedUserName: orderedUserName,
      OrderUserEmail: orderUserEmail,
      OrderNumber: orderNumber,
      IsOrderDesk: isOrderDesk,
      StyleType: style,
      StartDate: startDate,
      EndDate: endDate
    });
  }
}
